module.exports = __webpack_public_path__ + "img/study-abroad-hero-img.9b4378b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/study-abroad-hero-img.png
// module id = 75
// module chunks = 1